import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchContainer from './SearchContainer';
import { useSearch } from '../../api/availability/search';
import { useOutletContext } from 'react-router-dom';
import { AvailabilityGuardContext } from '../../routes/AvailabilityGuard';
import { BookNowFooter } from './BookNowFooter';
import { TableGuardOutletContext } from '../../routes/TableGuard';
import { useSupportedGroupSizes } from '../../api/availability/availability';
import { buildGroupSizeOptions } from '../shared/PartySizeSelector';
import { useTimeslot } from '../../api/getTimeslot';
import { useEstimateInvoice } from '../../hooks/useEstimateInvoice';
import { useFeatureFlags } from '../../api/getRestaurantFeatureFlags';
import { getSearchResult } from '../inventory-carousel/categorizeTables';

const SearchAvailabilities = () => {
	const { t } = useTranslation();
	const { restaurant, searchFilters } = useOutletContext<AvailabilityGuardContext>();
	const { table: selectedTable } = useOutletContext<TableGuardOutletContext>();
	const { estimatedInvoice } = useEstimateInvoice(restaurant, selectedTable, searchFilters);

	const { data: featureFlags } = useFeatureFlags(restaurant.id);
	const priceShown = !!featureFlags?.inclusivePricing ? estimatedInvoice?.total : estimatedInvoice?.subtotal;

	const searchSpace = selectedTable ? [selectedTable] : [];

	const { results, isLoading: isSearching } = useSearch({
		params: searchFilters,
		restaurantId: restaurant.id,
		space: searchSpace
	});

	const { data } = useTimeslot(
		selectedTable?.id,
		searchFilters.date,
		restaurant.id,
		searchFilters.time,
		searchFilters.groupSize
	);
	const { supportedGroupSizes, isLoading: isLoadingGroupSizes } = useSupportedGroupSizes({
		tables: [selectedTable]
	});
	const [groupSizeOptions] = buildGroupSizeOptions(supportedGroupSizes, null, false, t);

	const timeslot = data?.timeSlot;

	return (
		<SearchContainer
			isLoading={isSearching || isLoadingGroupSizes}
			results={results}
			tableIds={[selectedTable.id]}
			groupSizeOptions={groupSizeOptions}
			showSpecialEvents={false}
			footer={(
				<BookNowFooter
					disabled={isSearching || isLoadingGroupSizes}
					priceAmountTotaled={priceShown}
					displayUnit={timeslot?.isPerGuest ? 'guest' : `${selectedTable?.label ?? 'table'}`}
					bookingType={getSearchResult(results?.resultMap, selectedTable?.id)?.bookingType}
				/>
			)}
		/>
	);
};

export default SearchAvailabilities;